export const spacing_0 = '0rem'
export const spacing_0_125 = '0.125rem'
export const spacing_0_25 = '0.25rem'
export const spacing_0_5 = '0.5rem'
export const spacing_0_75 = '0.75rem'
export const spacing_1 = '1rem' // 16px
export const spacing_1_25 = '1.25rem' // 16px
export const spacing_1_5 = '1.5rem'
export const spacing_2 = '2rem' // 32px
export const spacing_2_5 = '2.5rem'
export const spacing_3 = '3rem'
export const spacing_4 = '4rem'
export const spacing_4_5 = '4.5rem'
export const spacing_5 = '5rem'
export const spacing_6 = '6rem'
